<div class="dialog-content-wrapper" *ngIf="!showError">

    <mat-toolbar class="green-600 m-0">
        <mat-toolbar-row fxFlex fxLayout="row" fxLayoutAlign="space-between center">
        </mat-toolbar-row>
    </mat-toolbar>
    <div mat-dialog-content class="p-16 pb-0 m-0" fxLayout="column" style="text-align: center;">
        <div>
            <mat-icon class="icon1">check_circle_outline</mat-icon>
        </div>
        <span class="title dialog-title">{{'Success' | translate}}!</span>
        <p class="message">{{msg | translate}}</p>

        <div style="padding: 20px;">
            <button mat-raised-button class="green-600" (click)="matDialogRef.close()">{{"okay" | translate}}</button>
        </div>

    </div>

</div>

<div class="dialog-content-wrapper" *ngIf="showError">
    <mat-toolbar class="warn m-0">
        <mat-toolbar-row fxFlex fxLayout="row" fxLayoutAlign="space-between center">
        </mat-toolbar-row>
    </mat-toolbar>
    <div mat-dialog-content class="p-16 pb-0 m-0" fxLayout="column" style="text-align: center;">
        <div>
            <mat-icon class="icon">error_outline</mat-icon>
        </div>
        <span class="title dialog-title">{{'Failed' | translate}}!</span>
        <p class="message">{{msg | translate}}</p>
        <div style="padding: 20px;">
            <button mat-raised-button class="warn" (click)="matDialogRef.close()">{{"okay" | translate}}</button>
        </div>

    </div>

</div>